export default "/images/vendor/flag-icon-css/flags/4x3/ec.svg?3ea7f906eaf807123a280d5806787ff2";